var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavMarkerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.024,
    height: 26.813,
    viewBox: "0 0 19.024 26.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.012,2a9.506,9.506,0,0,1,9.512,9.512c0,3.457-2.233,7.551-4.106,10.376a56.827,56.827,0,0,1-4.664,6.1l-.742.822-.742-.822c-.358-.4-8.77-9.787-8.77-16.479A9.506,9.506,0,0,1,16.012,2Zm0,23.787a57.855,57.855,0,0,0,3.739-5c1.721-2.6,3.773-6.312,3.773-9.271a7.512,7.512,0,0,0-15.024,0C8.5,16.365,13.983,23.364,16.012,25.787Zm0-18.315a4.04,4.04,0,1,1-4.04,4.04A4.045,4.045,0,0,1,16.012,7.472Zm0,6.08a2.04,2.04,0,1,0-2.04-2.04A2.042,2.042,0,0,0,16.012,13.552Z",
    transform: "translate(-6.5 -2)",
    fill: "#2cccd3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMarkerIcon);
export default __webpack_public_path__ + "static/media/nav-marker-icon.aa112de9.svg";
export { ForwardRef as ReactComponent };